// Imports
import styled from "styled-components"
import { Variables, Mixins } from "fajny-react"

import DemoCard from "../DemoCard"

const Container = styled(DemoCard)`
    @media ${Variables.Breakpoints.Mobile} {
        flex-direction: column;
    }
`

const Square = styled.span`
    height: 100%;
    width: 150px;
    background-color: ${({ $color }) => $color};

    @media ${Variables.Breakpoints.Mobile} {
        width: 100%;
        height: 150px;
    }
`

const Content = styled.span`
    padding: ${Variables.Spacers.S};
    ${Mixins.Grid({
        $gap: "xs",
    })};

    @media ${Variables.Breakpoints.Mobile} {
        width: 100%;
    }
`

export { Container, Square, Content }
